import { useState, useEffect } from "react"

export default function useInitialSetup(setupFunc, commitFunc = (result) => {}) {
  const [error, setError] = useState(false)
  useEffect(() => {
    let commit = true
    async function execute() {
      try {
        const result = await setupFunc()
        return commit && commitFunc(result)
      } catch (e) {
        setError(e)
      }
    }
    execute()
    return () => {
      commit = false
    }
  }, [])
  if (error) {
    throw error
  }
}
